
import { z } from "zod";

export const ContractorTypeValues = ["REMI_LABOR_ONLY", "REMI_LICENSED_LABOR", "REMI_PRO_CONTRACTOR", "REMI_TEAM_CONTRACTOR"] as const;
export const ContractorTypeSchema = /* @__PURE__ */ z.enum(ContractorTypeValues);
export const ContractorType: (typeof ContractorTypeSchema)["enum"] = { "REMI_LABOR_ONLY": "REMI_LABOR_ONLY", "REMI_LICENSED_LABOR": "REMI_LICENSED_LABOR", "REMI_PRO_CONTRACTOR": "REMI_PRO_CONTRACTOR", "REMI_TEAM_CONTRACTOR": "REMI_TEAM_CONTRACTOR" };
export type ContractorType = (typeof ContractorTypeValues)[number];
export const ContractorTypeDisplayNames = { "REMI_LABOR_ONLY": "Remi Labor Only",
"REMI_LICENSED_LABOR": "Remi Licensed Labor",
"REMI_PRO_CONTRACTOR": "Remi Pro Contractor",
"REMI_TEAM_CONTRACTOR": "Remi Team Contractor", } satisfies Record<ContractorType, string>;
